import React from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Route from './routes/route';

function App() {
  return (
    <BrowserRouter>
      <Route />
    </BrowserRouter>
  );
}

export default App;
